import 'react';
import { jsx } from 'react/jsx-runtime';

function SvgGooglePlusMono(props) {
  return /*#__PURE__*/jsx("svg", {
    width: "27",
    height: "22",
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.1355 9.54371H13.0747H10.9421H7.39266V11.5953H10.8328C10.3354 13.0646 8.96419 14.1204 7.34973 14.1204C5.31512 14.1204 3.66624 12.444 3.66624 10.3759C3.66624 8.30913 5.31512 6.63292 7.34973 6.63292C8.24109 6.63292 9.05591 6.95569 9.69295 7.49067H9.78913L11.3046 5.95053C10.2597 4.98789 8.87306 4.40027 7.34973 4.40027C4.10078 4.40027 1.4668 7.07698 1.4668 10.3759C1.4668 13.6784 4.10078 16.353 7.34973 16.353C7.77496 16.353 8.201 16.3081 8.6155 16.2141C9.45826 16.0289 10.2536 15.648 10.9336 15.1172C11.6097 14.5898 12.1668 13.9126 12.5612 13.1527C12.7615 12.7623 12.9202 12.3522 13.0318 11.9299C13.1471 11.4907 13.1423 11.0493 13.1374 10.6004C13.1365 10.5098 13.1355 10.419 13.1355 10.3278V9.54371ZM16.7718 12.9342H18.4952V11.2211H20.2087V9.49874H18.4952V7.78487H16.7718V9.49874H15.0596V11.2211H16.7718V12.9342Z",
      fill: "#42526E"
    })
  });
}

export { SvgGooglePlusMono as default };
